import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import { createFormComponent, createFormProviderComponent } from "./Form";
import { createFieldComponent } from "../Field";
import { createUseFieldValuesHook, createUseSetFieldValuesHook, createUseResetFormHook, createUseGetFieldValuesHook, createUseTriggerValidation, createUseFieldArray, createUseClearErrors } from "./Form.hooks";
import { createContext } from 'react';
export function createForm() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var FormContext = /*#__PURE__*/createContext(null);
  var formSymbol = Symbol();
  var utilities = {
    FormProvider: params !== null && params !== void 0 && params.provider ? createFormProviderComponent({
      FormContext: FormContext
    }) : undefined,
    Form: createFormComponent({
      provider: params.provider,
      formSymbol: formSymbol,
      FormContext: FormContext
    }),
    Field: createFieldComponent({
      formSymbol: formSymbol,
      FormContext: FormContext
    }),
    useResetForm: createUseResetFormHook({
      FormContext: FormContext
    }),
    useFieldValues: createUseFieldValuesHook({
      FormContext: FormContext
    }),
    useSetFieldValues: createUseSetFieldValuesHook({
      FormContext: FormContext
    }),
    useGetFieldValues: createUseGetFieldValuesHook({
      FormContext: FormContext
    }),
    useTriggerValidation: createUseTriggerValidation({
      FormContext: FormContext
    }),
    useFieldArray: createUseFieldArray({
      FormContext: FormContext,
      formSymbol: formSymbol
    }),
    useClearErrors: createUseClearErrors({
      FormContext: FormContext
    })
  };
  return utilities;
}